<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import DisplayIcon from '../icons/DisplayIcon.svelte';
	import { CloseIcon } from '../icons';
	import Button from '../button/Button.svelte';

	import FontSpan from '../typography/FontSpan.svelte';

	const dispatchClose = createEventDispatcher<{ closed: boolean }>();
	const dispatchLink = createEventDispatcher<{ link: boolean }>();

	export let open = false;

	function toggle() {
		open = !open;
		if (!open) {
			dispatchClose('closed', true);
		}
	}

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			open = false;
			dispatchClose('closed', true);
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />
<div
	class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-40"
	class:opacity-0={!open}
	class:pointer-events-none={!open}
>
	<div class="modal-overlay absolute w-full h-full" />

	<div class="modal-container z-50">
		<div
			role="button"
			tabindex="0"
			on:click={toggle}
			on:keypress={handleKeydown}
			class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
		>
			<DisplayIcon size={18} icon={CloseIcon} css="fill-current text-white" />
			<span class="text-sm">(Esc)</span>
		</div>
		<div class="modal-content relative">
			<!--Body-->
			<div class="modal-body">
				<div class="flex flex-col items-center gap-6">
					<div class="flex flex-col items-center self-stretch gap-10">
						<FontSpan varient="body-B-02" class="text-white">Link external wallets</FontSpan>
						<div class="flex flex-col link-container">
							<div class="flex flex-col items-center">
								<FontSpan varient="body-R-05" class="text-gray-50">Use your NFTs in</FontSpan>
								<FontSpan varient="body-B-03" class="text-gray-50">external wallet</FontSpan>
							</div>
							<div class="icon icon-link-external-wallet140" />
							<Button
								on:click={() => {
									dispatchLink('link', true);
								}}
								type="primary"
								class="h-11 px-6"
							>
								<FontSpan varient="body-EB-02" class="text-white">Link</FontSpan>
							</Button>
						</div>
						<div class="flex flex-col gap-2 items-center">
							<FontSpan varient="body-R-05" class="text-gray-50 w-[428px] text-center">
								To use NFTs in your external wallet, it needs to be linked to <br /> your account
							</FontSpan>
							<div
								role="button"
								tabindex="0"
								class="flex cursor-pointer"
								on:click={toggle}
								on:keypress
							>
								<FontSpan varient="body-EB-04" class="text-primary-600">Remind me later</FontSpan>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.link-container {
		display: flex;
		width: 310px;
		padding: 48px 32px;
		flex-direction: column;
		align-items: center;
		gap: 24px;

		border-radius: 30px;
		background: var(--gray-200, #282828);
	}
	.modal-container {
		display: flex;
		padding-top: 48px;
		padding-bottom: 48px;
		padding-left: 24px;
		padding-right: 24px;
		flex-direction: column;
		align-items: center;
		gap: 40px;

		border-radius: 30px;
		border: 1px solid var(--popup-border, #2d2d2d);
		background: var(--bg, #151516);

		/* popup_shadow */
		box-shadow: 0px 0px 20px 0px rgba(189, 189, 189, 0.2);
	}
	.modal-overlay {
		background: rgba(0, 0, 0, 0.8);
		backdrop-filter: blur(8px);
	}

	.modal {
		transition: opacity 0.25s ease;
	}
</style>
